import { BrowserStorage } from "@jti/rest-api";
const storage = new BrowserStorage();
const PAYMENT_TOKEN = "paymentToken";
export const setPaymentTokenToStorage = (token) => storage.set(PAYMENT_TOKEN, token);
export const getPaymentTokenFromStorage = (defaultValue = "") => storage.get(PAYMENT_TOKEN, "") || defaultValue;
export const deletePaymentTokenFromStorage = () => storage.delete(PAYMENT_TOKEN);
//# sourceMappingURL=paymentToken.js.map